import axios from 'axios';

/**
 * @param {import('axios').Method} httpMethod HTTP method to perform
 * @param {string} proxyLocation Full API location (WITHOUT LEADING SLASH) for the request like
 * api/v2/content_metadata/:id/more/path/stuff
 * @param {?import('axios').AxiosRequestConfig<any>} config params, post body, etc. that are rested
 *  into the axios request.
 */
function proxyRequest(
    httpMethod,
    proxyLocation,
    config = {}
) {
    /** @type {import('axios').AxiosRequestConfig} */
    return axios({
        method: httpMethod,
        url: `/api/proxy/${proxyLocation}`,
        ...config
    });
}

export const httpMethods = {
    GET: 'get',
    HEAD: 'head',
    POST: 'post',
    PUT: 'put',
    PATCH: 'patch',
    DELETE: 'delete'
};

export default proxyRequest;



// WEBPACK FOOTER //
// ./proxy_api_client.js